import { useIsChuseokCallOff } from "goi_common";
import { Box, Pagination, PaginationItem } from "@mui/material";
import Stack from "@mui/material/Stack";
import {
  BTypeParlorCompare,
  ColorIcon,
  GOI_WEB_URL,
  Link,
  Spacing,
  call,
  colors,
  customEvent,
} from "goi_common";

import { GetStaticPaths, GetStaticProps } from "next/types";
import Head from "next/head";

import { getParlorCremaFacilityList } from "pages/funeral-recommend/[parlor]/[crema]/[facility]";

export const getStaticPaths: GetStaticPaths = () => {
  const parlorCremaFacilityList = getParlorCremaFacilityList();
  const totlaPageNum = Math.ceil(parlorCremaFacilityList.length / MAX_LIMIT);
  const pathList = Array.from({ length: totlaPageNum }, (_, index) => ({
    params: { pageNum: String(index + 1) },
  }));

  return {
    paths: pathList,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = ({ params }) => {
  const pageNum = Number(params?.pageNum);

  const parlorCremaFacilityList = getParlorCremaFacilityList();
  const totalPageNum = Math.ceil(parlorCremaFacilityList.length / MAX_LIMIT);
  const totalCount = parlorCremaFacilityList.length;

  const items = parlorCremaFacilityList.slice(
    (pageNum - 1) * MAX_LIMIT,
    pageNum * MAX_LIMIT
  );

  const title = `서울경기인천 장례식장x화장장x장지 추천리스트 ${pageNum}번 수도권 장례 준비 한 번에 | 서울경기인천장례정보포털`;
  const description = `서울경기인천지역 장례식장 화장장 장지 추천리스트입니다. 총 ${totalCount}개의 목록이 있으니 살펴보시고 수도권 장례 준비를 고민없이 한 번에 진행해보시기 바랍니다. | 서울경기인천장례정보포털`;

  return {
    props: {
      items,
      totalPageNum,
      pageNum,
      pageOgTitle: title,
      pageDescription: description,
      pageOgDescription: description,
    },
  };
};

const MAX_LIMIT = 100;
const PAGE_PATH = "fune_recom_list";

// export const getServerSideProps: GetServerSideProps = async ({ params }) => {
//   const { pageNum } = params as { pageNum: string };

//   const title = `서울경기인천 장례식장x화장장x장지 추천리스트 ${pageNum}번 수도권 장례 준비 한 번에 | 서울경기인천장례정보포털`;
//   const description = `서울경기인천지역 장례식장 화장장 장지 추천리스트들입니다. 총 ${count} 개의 목록이 있으니 수도권 장례 준비를 고민없이 한 번에 진행해보시기 바랍니다. | 서울경기인천장례정보포털`;

//   // 총 개수를 구해서 MAX_LIMIT으로 나눈다.

//   return {
//     props: {
//       pageOgTitle: title,
//       pageDescription: description,
//       pageOgDescription: description,
//       paths: showList,
//       count,
//     },
//   };
// };

type StringKeyObject = { [key: string]: any };

interface FuneralRecommendListPageProps {
  totalPageNum: number;
  pageNum: number;
  items: {
    parlor: StringKeyObject;
    crema: StringKeyObject;
    facility: StringKeyObject;
  }[];
}

const FuneralRecommendListPage = ({
  totalPageNum,
  pageNum,
  items,
}: FuneralRecommendListPageProps) => {
  const isChuseokCallOff = useIsChuseokCallOff();
  return (
    <>
      <Head>
        <link
          rel="canonical"
          href={`https://www.metropolitan-funeral.co.kr/funeral-recommend/list/${pageNum}/`}
          key="canonical"
        />
        {/* <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqList) }}
    /> */}
      </Head>

      <Stack
        flexDirection="row"
        justifyContent="center"
        gap="44px"
        padding="24px 0 60px"
      >
        {/* 2026 추석. 연휴에는 못 받는 전화라 이 버튼만 내린다. */}
        {!isChuseokCallOff && (
          <Stack
            alignItems="center"
            onClick={() => {
              call("1666-9784");
              customEvent({
                domain: "metro",
                path: PAGE_PATH,
                trigger_and_target: "goi_call",
              });
            }}
          >
            <ColorIcon name="symbol-call" size={56} color="black" />
            <Box className="subtitle_14_sb">긴급 장례 상담</Box>
          </Stack>
        )}
        <Box height="65px" width="1px" style={{ background: colors.gray500 }} />
        <Link
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          href={GOI_WEB_URL + "/service/flower/?utm_source=dogsound"}
          event={{
            domain: "metro",
            path: PAGE_PATH,
            trigger_and_target: "uv_wreath_req_btom",
          }}
        >
          <ColorIcon name="flower-line" size={56} color="black" />
          <Box
            className="subtitle_14_sb black"
            style={{ textDecoration: "none" }}
          >
            화환 2시간 배송
          </Box>
        </Link>
      </Stack>
      <Stack alignItems="center" className="subtitle_16_b gray900" mb="6px">
        <h2>서울인천경기 장례식장/화장장/장지 조합을 추천드립니다. </h2>
        <Spacing gap={20} />

        <Stack gap="20px">
          {items.map(({ parlor, crema, facility }, index) => {
            const key = `${parlor.id}_${crema.id}_${facility.id}`;
            const href = `/funeral-recommend/${parlor.companyname}/${crema.companyname}/${facility.companyname}/`;
            const linkTitle = `${parlor.companyname}x${crema.companyname}x${facility.companyname} 추천조합`;

            return (
              <Link
                key={key}
                href={href}
                title={linkTitle}
                event={{
                  domain: "metro",
                  path: PAGE_PATH,
                  trigger_and_target: "uv_fune_recom",
                }}
              >
                <Box
                  className="gray600"
                  style={{
                    background: "white",
                    boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
                    borderRadius: "5px",
                    padding: "20px",
                  }}
                >
                  <BTypeParlorCompare
                    firstParlor={parlor}
                    secondParlor={crema}
                    twiceParlor={facility}
                    index={index}
                  />
                </Box>
              </Link>
            );
          })}
        </Stack>

        <Stack
          flexDirection="row"
          justifyContent="center"
          gap="44px"
          padding="24px 0 60px"
        >
          <Pagination
            count={totalPageNum}
            page={pageNum}
            renderItem={(item) => {
              if (
                item.page === null ||
                !item.page ||
                item.page > totalPageNum
              ) {
                return <PaginationItem {...item} />;
              }

              return (
                <Link
                  href={`/funeral-recommend/list/${item.page}`}
                  event={{
                    domain: "metro",
                    path: PAGE_PATH,
                    trigger_and_target: "uv_fune_recom_list",
                  }}
                >
                  <PaginationItem {...item} />
                </Link>
              );
            }}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default FuneralRecommendListPage;
